import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const getCategories = createSelector(
  state => state.orm,
  ormCreateSelector(orm, session => {
    return session.PlanCategory.all().toModelArray()
  })
)

export const getLastSelectedCategory = createSelector(
  state => state.orm,
  state => state.ui.planCategories.selectedCategorySlug,
  ormCreateSelector(orm, (session, currCategorySlug) => {
    return session.PlanCategory.withId(currCategorySlug)
  })
)
